import Delete from '@mui/icons-material/Delete';
import { FC } from 'react';

import { RoundButton } from './button/icon-button';

import { useUserPermissions } from '@/hooks/use-user-permissions';
import { useTelmaPortalStore } from '@/store/telma-portal-store';
import { useSaveBotVersionEnabled } from 'utils/hooks/use-save-bot-version-enabled';

export interface RemoveNodeButtonProps {
    nodeId: string;
    backgroundColor?: string;
}

export const RemoveNodeButton: FC<RemoveNodeButtonProps> = ({
    nodeId,
    backgroundColor,
}) => {
    const { isBotEditor } = useUserPermissions();

    const [onNodesRemove, clearNodeHandles] = useTelmaPortalStore((state) => [
        state.onNodesRemove,
        state.clearCustomModuleNodeHandles,
    ]);

    const saveEnabled = useSaveBotVersionEnabled();

    return (
        <RoundButton
            hoverColor={backgroundColor}
            style={{ marginBottom: '10px' }}
            disabled={!isBotEditor || !saveEnabled}
            onClick={(e: any) => {
                onNodesRemove([nodeId]);
                clearNodeHandles(nodeId);
                e.stopPropagation();
            }}
            onMouseDown={(e: any) => e.stopPropagation()}
        >
            <Delete />
        </RoundButton>
    );
};
